<template>
  <div>
    <TopBar title="Panier" :cart="false"/>

    <div class="modal fade" tabindex="-1" id="scan"  aria-labelledby="scan" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body small">
            <div class="modal-body text-center small">
              <i class="fa fa-4x fa-info-circle text-secondary m-b15"></i>
              <h5 class="">Garder la même table pour la commande?</h5>
              <div class="text-center m-t20">
                <button @click.prevent="startScanning" class="btn btn-sm btn-light m-r10">Non</button>
                <button @click.prevent="makeOrder" class="btn btn-sm btn-secondary">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Oui
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div v-if="startScanner" class="container">
        <Scanner v-model="table_id"/>
      </div>
      <div v-else>
        <div class="container">
          <PanierRow v-for="(order,index) in orders" :key="index" :index="index" :order="order" />
        </div>
        <br><br> <br> <br> <br><br> <br> <br><br><br> <br> <br>
        <div class="footer fixed">
          <div class="footer-wrapper container">
            <div class="">
              <div class="d-flex justify-content-between ">
                <p class="item-title mb-0 text-dark">Nombre de plats</p>
                <p class="item-title mb-0 text-dark">{{orders.length}}</p>
              </div>
              <div class="d-flex justify-content-between dash">
                <p class="item-title mb-0 text-success">Total</p>
                <p class="item-title mb-0 text-success">{{ordersTotal}} f</p>
              </div>
            </div>
            <button @click.prevent="checkAndCollectDataForOrdering" class="btn btn-sm mt-2 btn-primary w-100 btn-rounded" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ $t('commander') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import PanierRow from "@/components/panierRow";
import Scanner from "@/components/scanner";
import {useStore} from "vuex";
import { toast } from 'vue3-toastify';
import {useRouter} from "vue-router";

const store = useStore()
const router = useRouter()
const loading = ref(false)
const startScanner = ref(false)
const table_id = ref('')

onMounted(() => {

})

watch(() => table_id.value, () => {
  if(table_id.value){
   startScanner.value = false
   makeOrder()
 }
})

const orders = computed(() => store.getters['cart/orders'])
const ordersTotal = computed(() => store.getters['cart/orders'].reduce((a,b) => a + b.total, 0))
const table = computed(() => store.getters['contact/table'])

function checkAndCollectDataForOrdering(){
  if(table.value){
    //makeOrder
    $('#scan').modal('show')
  }else {
    startScanner.value = true
  }
}

function startScanning(){
  $('#scan').modal('hide')
  startScanner.value = true
}

function makeOrder(){
  loading.value = true
  $('#scan').modal('hide')
  let ordersRequest = formatOrders()
  let data = {
    table_id: table.value,
    order: ordersRequest
  }
  store.dispatch('cart/makeOrder', data).then((response) => {
    store.dispatch('order/loadOrders')
    toast.success('Votre commande a été envoyé avec succès. Merci!')
    router.push({name: "home-page"})
  }).finally(() => {
    loading.value = false
  })
}



function formatOrders(){
  let ordersFormatted = []

  orders.value.forEach((order => {
    let deduplicatedMeals = deduplicateArrayObject(order.meals)
    let deduplicatedAccompaniements = deduplicateArrayObject(order.accompaniements)

    let mergedOrderMealsWithAccompaniements = mergeMealsAndAccompaniements(deduplicatedMeals,deduplicatedAccompaniements)
    let groupedMeals = groupeMealsByMealIdAndAccompaniementId(mergedOrderMealsWithAccompaniements);

    groupedMeals[groupedMeals.length-1].supplements = order.supplements
    groupedMeals[groupedMeals.length-1].comment = order.comment

    ordersFormatted = [...ordersFormatted, ...groupedMeals]

  }))

  return ordersFormatted
}

function deduplicateArrayObject(arrayToDeduplicate){
  let deduplicatedArray = [];
  arrayToDeduplicate.map(element => {
    let repeatedElement = makeRepeated([
      {
        id:element.id,
        quantity: 1,
      }
    ], element.quantity)

    deduplicatedArray = [...deduplicatedArray, ...repeatedElement]
  })

  return deduplicatedArray
}

function makeRepeated(arr, repeats) {
  return Array.from({ length: repeats }, () => arr).flat();
}

function mergeMealsAndAccompaniements(meals, accompaniements){
  let mergedArray = []
  meals.map((meal,index) => {
    let mealToMerged = {
      meal_id:meal.id,
      quantity: meal.quantity,
      accompaniement_id: '',
      comment: '',
      supplements: []
    }

    if(accompaniements.length > index){
      mealToMerged['accompaniement_id'] = accompaniements[index].id
    }
    mergedArray.push(mealToMerged)
  })

  return mergedArray
}

function groupeMealsByMealIdAndAccompaniementId(meals){
  let groupedMeals = []
  meals.map(meal => {
    let index = groupedMeals.findIndex(groupedMeal =>
        groupedMeal.meal_id == meal.meal_id
        && groupedMeal.accompaniement_id == meal.accompaniement_id)

    if(index == -1){
      groupedMeals.push(meal)
    }else {
     groupedMeals[index].quantity +=1
    }
  })

  return groupedMeals
}

</script>
<style scoped>
.footer.fixed {
  bottom: 59px;
}
.item-title{
  font-weight: bold;
}
</style>